import { render, staticRenderFns } from "./CustomExtensionAccess.vue?vue&type=template&id=153fd922&scoped=true&"
import script from "./CustomExtensionAccess.vue?vue&type=script&lang=ts&"
export * from "./CustomExtensionAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153fd922",
  null
  
)

export default component.exports